export const toBase64 = async (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const base64String = reader.result
                .replace("data:", "")
                .replace(/^.+,/, "");
            resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
    });

export const groupParamsByKey = (params) =>
    [...(params?.entries() ?? [])].reduce((acc, tuple) => {
        const [key, val] = tuple;
        if (acc.hasOwnProperty(key)) {
            if (Array.isArray(acc[key])) {
                acc[key] = [...acc[key], val];
            } else {
                acc[key] = [acc[key], val];
            }
        } else {
            acc[key] = val;
        }

        return acc;
    }, {});
